var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { getSchemaModifierStyles } from '../../../contexts/designs/utils';
import { styledWithoutNonHTMLProps } from '../../../theme/utils';
import { SCHEME_MODIFIERS } from '../../../types/Designs.types';
import { Link } from '../Link';
export var StyledLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), getSchemaModifierStyles(SCHEME_MODIFIERS.default));
export var logoOverallStyles = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), getSchemaModifierStyles(SCHEME_MODIFIERS.default));
export var StyledLogo = styledWithoutNonHTMLProps('img', ['design', 'config'])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), logoOverallStyles);
var templateObject_1, templateObject_2, templateObject_3;
